import angular from 'angular';

angular
    .module('company')

    .factory('CompanyService', [
        '$resource',
        'CONF',
        'API_CONFIG',
        function ($resource, CONF, API_CONFIG) {
            var Company = $resource(
                CONF.apiContext + CONF.apiBaseUrl + '/v1/company/searchByCriteria',
                {},
                {
                    // Recherche suivant les critères
                    searchByCriterias: {
                        method: 'POST',
                        isArray: true,
                    },
                    // Compte le nombre containers pour chaque société
                    countContainer: {
                        method: 'POST',
                        url: API_CONFIG.url + '/v1/company/countContainer',
                        isArray: true,
                    },
                    autocompleteNameId: {
                        method: 'POST',
                        url: CONF.apiContext + CONF.apiBaseUrl + '/v1/company/autocomplete',
                        isArray: true,
                    },
                    autocompleteCompanyName: {
                        method: 'POST',
                        url: CONF.apiContext + CONF.apiBaseUrl + '/v1/company/autocomplete/name',
                        isArray: true,
                    },
                    searchRelations: {
                        method: 'POST',
                        url: CONF.apiContext + CONF.apiBaseUrl + '/v1/company/:companyId/search-relations',
                        isArray: false,
                    },
                }
            );

            // Ajout de la propriété fullname
            Object.defineProperty(Company.prototype, 'fullname', {
                get: function () {
                    return this.companyId + ', ' + this.companyName;
                },
            });

            // Ajout de la propriété fullname du principal
            Object.defineProperty(Company.prototype, 'principalFullname', {
                get: function () {
                    return this.principalId + ', ' + this.principalName;
                },
            });
            // Ajout de la propriété EidWithID
            Object.defineProperty(Company.prototype, 'DoEidWithId', {
                get: function () {
                    return this.principalEid + ' (' + this.principalAppId + ')';
                },
            });

            return Company;
        },
    ]);
